import { PrivateRouteHeader } from "@/components/app-layout/private-route-header";
import { makeStyles } from "@fluentui/react-components";
import { ADDIN_VERSION } from "@/constants";
import React, { ReactNode } from "react";

const useStyles = makeStyles({
  version: {
    fontSize: "12px",
    color: "rgba(153, 153, 153, 0.2)",
    textAlign: "right",
    marginTop: "10px",
  },
});

export const AppLayout = ({ children, isPublic }: { children: ReactNode; isPublic: boolean }) => {
  const styles = useStyles();
  return (
    <div>
      {!isPublic && <PrivateRouteHeader />}
      <div>{children}</div>
      <p className={styles.version}>{ADDIN_VERSION}</p>
    </div>
  );
};
